import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang, categoryName } from "@/i18n";

export default function SectionHeader({ category, emoji }) {
  const { lang, t } = useLang();
  return (
    <div className="flex items-end justify-between border-b-2 border-white pb-2 mb-6" data-testid={`section-${category}`}>
      <div className="flex items-center gap-3">
        <span className="text-2xl" aria-hidden>{emoji}</span>
        <h2 className="headline text-3xl sm:text-4xl tracking-tight text-white">
          {categoryName(category, lang)}
        </h2>
      </div>
      <Link
        to={`/category/${category}`}
        className="text-xs font-bold uppercase tracking-wider text-neutral-400 hover:text-red-500 transition-colors flex items-center gap-1"
        data-testid={`section-link-${category}`}
      >
        {t("view_all")} <ArrowRight size={14} />
      </Link>
    </div>
  );
}
